export const BINGO_SIDE_BET_TYPE = 1

export const BINGO_SIDE_BET_DEFAULT = {
  type: BINGO_SIDE_BET_TYPE,
  key: 'bingo',
  title: 'Bingo',
  enabled: true,
  order: 1,
  min: '',
  max: ''
}
